import { Box } from '@mui/material'
import { ReactComponent as DeviationLogo } from 'assets/deviation_logo.svg'
import { ReactComponent as WaitingLogo } from 'assets/waiting_logo.svg'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import TooltipHover from 'ui/TooltipHover'
import {
	isEventMissed,
	isEventTimePending,
	isFactTimeDeviation,
} from './feedPlanDeviation'

const clockSx = {
	display: 'inline-flex',
	lineHeight: 0,
	color: COLORS.icon,
	'& svg circle, & svg path': {
		stroke: 'currentColor',
	},
	'&:hover': {
		color: COLORS.main,
	},
}

const HoverClock = ({ title, missed }: { title: string; missed?: boolean }) => (
	<Box
		component='span'
		sx={{
			...clockSx,
			...(missed
				? {
						color: COLORS.deviationFont,
					}
				: {}),
		}}
	>
		<TooltipHover
			title={title}
			placement='top'
			oneLine
			disableHoverBackground
			inline
		>
			<WaitingLogo />
		</TooltipHover>
	</Box>
)

const FactTimeValue = ({
	factDt,
	planTime,
	date,
	deviation,
	offsetX = 0,
}: {
	factDt?: number | null
	planTime?: string | null
	date?: Date | string | null
	deviation?: number | string | null
	offsetX?: number
}) => {
	const time = factDt ? moment(factDt).format('HH:mm') : ''
	const hasTimeDeviation =
		Boolean(factDt) && isFactTimeDeviation(factDt, planTime, date, deviation)

	let content = <WaitingLogo />
	if (factDt) {
		content = <>{time}</>
	} else if (isEventMissed(factDt, date)) {
		content = <HoverClock title='Событие пропущено' missed />
	} else if (isEventTimePending(planTime, date)) {
		content = <HoverClock title='Время события еще не наступило' />
	}

	return (
		<Box
			component='span'
			sx={{
				position: 'relative',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '128px',
				height: '40px',
				verticalAlign: 'middle',
				boxSizing: 'border-box',
				fontSize: '14px',
				lineHeight: '17px',
				fontWeight: 400,
				color: COLORS.black,
			}}
		>
			{hasTimeDeviation ? null : content}
			{hasTimeDeviation && (
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: `translate(calc(-50% + ${offsetX}px), -50%)`,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '166px',
						height: '40px',
						boxSizing: 'border-box',
						backgroundColor: COLORS.deviation,
						borderRadius: '12px',
						pointerEvents: 'none',
					}}
				>
					{time}
					<Box
						sx={{
							position: 'absolute',
							right: '12px',
							display: 'flex',
							transform: 'rotate(180deg)',
						}}
					>
						<DeviationLogo />
					</Box>
				</Box>
			)}
		</Box>
	)
}

export const WeightDeviationValue = ({ value }: { value: string }) => (
	<Box
		component='span'
		sx={{
			display: 'inline-flex',
			alignItems: 'center',
			gap: '6px',
			backgroundColor: COLORS.deviation,
			color: COLORS.deviationFont,
			borderRadius: '8px',
			padding: '4px 8px',
			fontSize: '14px',
			lineHeight: '17px',
			fontWeight: 400,
		}}
	>
		{value}
		<Box component='span'>кг</Box>
		<DeviationLogo />
	</Box>
)

export default FactTimeValue
